import Modal from "./modal";
import PrimaryButton from "./PrimaryButton";
import {inject, observer} from "mobx-react";

function NoTicketsPopup({DeviceStore, onClick, onCancel}){

  const {t, theme} = DeviceStore;

  const cancel = () => {
    onCancel();
  }

  return (
      <Modal visible={true} showClose={false} onClose={cancel} center={true}>
        <div className="p-4">
          <p className="dark:text-white mb-4">
            {t('no_tickets_selected')}
          </p>
          <div className="justify-end flex items-center">
            <button className="dark:text-white p-2 mr-2 text-sm" onClick={cancel}>{t('back')}</button>
            <PrimaryButton theme={theme} label={t('continue')} onClick={onClick}/>

          </div>
        </div>
      </Modal>
  )

}

export default inject("DeviceStore")(observer(NoTicketsPopup));
